import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {
  email: {
    required,
    email
  },
  password: {
    required,
    minLength: minLength(3)
  },
  password_confirmation: {
    required,
    minLength: minLength(3),
    sameAsPassword: sameAs('password')
  }
}